import { PersonFullFragment } from './fragments/fragment-person-full';
import { gql } from '@apollo/client';
import { getClient } from '../client-graphql';
import { PersonFullFragmentFragment } from '@fm-nx/contentful-types';
import { ImageWrapperFragment } from './fragments/fragment-image-wrapper';
import { InternalPageLinkFragment } from './fragments/fragment-internal-page-link';

export const PersonFragment = gql(`
    fragment PersonFragment on Person {
        ...PersonFullFragment
    }
`);

export async function getPersonById(id: string, preview = false) {
    type PersonQueryResponse = {
        personCollection?: {
            items: PersonFullFragmentFragment[];
        };
    };
    const { data } = await getClient(preview).query<PersonQueryResponse>({
        query: gql`
            query GetPersonById($id: String!, $preview: Boolean) {
                personCollection(where: { sys: { id: $id } }, preview: $preview) {
                    items {
                        ...PersonFullFragment
                    }
                }
            }
            ${PersonFullFragment}
            ${ImageWrapperFragment}
            ${InternalPageLinkFragment}
        `,
        variables: {
            id,
            preview,
        },
    });
    return data?.personCollection?.items?.[0];
}
